<script lang="ts">
	import { preventDefault } from "svelte/legacy"

	import { Toast } from "toaster"
	import { MassUpdater } from "./MassUpdateController"
	import { closeOverlay } from "overlay"

	let id: number = $state()
	let isLoading: boolean = $state(false)

	async function submit() {
		isLoading = true

		if (!id) {
			isLoading = false
			Toast.error("Must select an ID")
			return
		}

		try {
			await MassUpdater.addDevice(id)
			closeOverlay()
		} catch (e) {
			Toast.error(`Unable to add device ID ${id}...`)
		}

		isLoading = false
	}
</script>

<form id="indiv-id-input" onsubmit={preventDefault(submit)}>
	<div class="input-container">
		<label for="id-input"
			>ID:
			<input id="id-input" type="number" bind:value={id} />
		</label>
	</div>
	<button type="submit" disabled={isLoading}>Ok</button>
</form>

<style>
	#indiv-id-input {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;
		padding-top: 1rem;
	}

	input[type="number"] {
		width: 5rem;
	}

	button {
		margin-top: 1rem;
	}
</style>
